import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/core/Menu";
import { Menu as MenuIcon } from "@material-ui/icons";
import GetAppIcon from "@material-ui/icons/GetApp";

import "./Header.css";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      communityEl: null,
      facultyEl: null,
      displayRoute: props.displayRoute,
      scrolled: false,
    };
    this.routes = [
      {
        name: "Home",
        link: "/",
      },

      {
        name: "Committee",
        link: "/committee",
      },
      {
        name: "Pre Conference Workshop",
        link: "/pre-conference-workshop",
      },
      {
        name: "Scientific Schedule",
        link: "/scientific-schedule",
      },
      {
        name: "Near by Places",
        link: "/nearby-places",
      },
      {
        name: "Contact",
        link: "/contact",
      },
      {
        name: "E-Certificate",
        link: "/feedback",
        download: true,
      },
      {
        name: "Abstract",
        link: "/call-for-abstracts",
      },
    ];

    this.eventCommittee = [
      {
        name: "ABSTP Executive Committee",
        link: "/executive-committee",
      },
      {
        name: "Organizing Committee",
        link: "/organizing-committee",
      },
    ];

    this.scientificProgram = [
      { name: "Academic Agenda", link: "/scientific-program" },
      { name: "Pre-conference Workshops", link: "/workshop" },
      { name: "Call for Abstracts", link: "/call-for-abstracts" },
      { name: "Call for Symposium", link: "/call-for-symposium" },
      { name: "Call for Panel Discussion", link: "/call-for-panel-discussion" },
      { name: "Call for Postgraduate Quiz Competition", link: "/call-for-quiz-competition" },
    ];
  }

  handleScroll = () => {
    const scrollY = this.scrollContainer === window ? window.scrollY : this.scrollContainer.scrollTop;
    const scrolled = scrollY > 60;
    if (scrolled !== this.state.scrolled) {
      this.setState({ scrolled });
    }
  };

  componentDidMount() {
    this.scrollContainer = document.querySelector(".screen-container") || window;
    this.scrollContainer.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.setState({ drawerOpen: false });
    }
    if (this.props.match.params.name !== prevProps.match.params.name) {
      this.setState({ communityEl: null, open: false });
    }
  }

  handleOpen = (event, type) => {
    if (type === "community") {
      this.setState({ communityEl: event.currentTarget, open: true });
    } else {
      this.setState({ facultyEl: event.currentTarget, open: true });
    }
  };

  handleClose = () => {
    this.setState({ communityEl: null, facultyEl: null, open: false });
  };

  navigateTo = (route) => {
    if (route === "/contact") {
      const footer = document.getElementById("footer");
      if (footer) footer.scrollIntoView({ behavior: "smooth" });
    } else {
      this.props.history.push(route);
    }
    this.toggleDrawer(false);
    this.handleClose();
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    const pathname = this.props.history.location.pathname;
    const isTransparentPage = pathname === "/" || pathname.startsWith("/committee") || pathname.startsWith("/call-for-abstracts");
    const headerClass = isTransparentPage ? `header${this.state.scrolled ? " scrolled" : ""}` : "header solid";

    return (
      <header className={headerClass}>
        <div className="nav-row-2">
          <div className="nav-wrapper">
            <div className="nav-left" onClick={() => this.navigateTo("/")}>
              <img src="/abstp.png" alt="ABSTP" className="banner-soca-logo" />
              <div className="banner-info-block">
                {/* <p className="banner-conf-title">
                  15th International Conference
                  <br />
                  of the Society of Clinical Anatomists
                </p> */}
                <p className="banner-conf-meta">
                  2<sup style={{ fontSize: "0.8rem" }}>nd</sup> BIENNIAL CME & WORKSHOP 2026 <br /> LUCKNOW
                  {/* <br />
                  Dr. RMLIMS, Lucknow(U.P.) India. */}
                </p>
              </div>
            </div>
            <nav className="nav-links">
              <div className="nav-center">
                {this.routes.map((route, index) => {
                  if (route.name === "Committee") {
                    return (
                      <React.Fragment key={index}>
                        <Button className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                          Committee
                        </Button>
                        <Menu
                          anchorEl={this.state.communityEl}
                          open={this.state.open && this.state.communityEl !== null}
                          onClose={this.handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}>
                          <div className="committee-dropdown">
                            <div className="committee-header">
                              <h4 className="dropdown-header">Event Committee</h4>
                            </div>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>

                              {/* <div className="committee-divider" /> */}

                              {/* <div className="committee-subsection">
                                {this.SocaCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div> */}
                            </div>
                          </div>
                        </Menu>
                      </React.Fragment>
                    );
                  }

                  return (
                    <Button
                      key={index}
                      className={`link-btn ${route.name === "Abstract" || route.download ? "nav-link-btn abstract-btn" : ""}`}
                      startIcon={route.download ? <GetAppIcon fontSize="small" /> : undefined}
                      onClick={() => this.navigateTo(route.link)}>
                      {route.name}
                    </Button>
                  );
                })}
              </div>
              <Button
                className="nav-link-btn abstract-btn"
                color="primary"
                variant="outlined"
                onClick={() => this.navigateTo("/registration")}>
                Register Now
              </Button>
              <a
                style={{
                  textDecoration: "none",
                  textTransform: "uppercase",
                }}
                href="/brochure-30Jul2026.pdf"
                target="_blank"
                rel="noopener noreferrer">
                <Button color="primary" variant="contained" className="nav-link-btn abstract-btn brochure-nav-btn">
                  Download Brochure
                </Button>
              </a>
            </nav>

            <div className="header-menu-bar">
              <MenuIcon fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>

            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <div
                    className="drawer-header-block"
                    onClick={() => this.navigateTo("/")}
                    style={{
                      cursor: "pointer",
                      padding: "10px 20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "15px",
                    }}>
                    <img src="/abstp.png" alt="logo" className="drawer-logo" style={{ margin: 0 }} />
                    <div className="banner-info-block mobile-banner-info">
                      <p className="banner-conf-meta" style={{ fontSize: "12px", marginTop: "5px" }}>
                        2<sup style={{ fontSize: "0.8rem" }}>nd</sup> BIENNIAL CME & WORKSHOP 2026 <br /> LUCKNOW
                      </p>
                    </div>
                  </div>

                  {this.routes.map((route, index) => {
                    if (route.name === "Committee") {
                      return (
                        <React.Fragment key={index}>
                          <Button key={index} className="link-btn" onClick={(e) => this.handleOpen(e, "community")}>
                            Committee
                          </Button>
                          <Menu
                            anchorEl={this.state.communityEl}
                            open={this.state.open && this.state.communityEl !== null}
                            onClose={this.handleClose}>
                            <div className="committee-content">
                              <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">Event Committee</h4>
                                {this.eventCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div>
                              {/* <div className="committee-subsection">
                                <h4 className="mobile-dropdown-header">SOCA Executives</h4>
                                {this.SocaCommittee.map((member, index) => (
                                  <Button key={index} className="menu-link-btn" onClick={() => this.navigateTo(`/committee${member.link}`)}>
                                    {member.name}
                                  </Button>
                                ))}
                              </div> */}
                            </div>
                          </Menu>
                        </React.Fragment>
                      );
                    }

                    return (
                      <Button
                        key={index}
                        className={`link-btn ${route.name === "Abstract" || route.download ? "nav-link-btn abstract-btn" : ""}`}
                        startIcon={route.download ? <GetAppIcon fontSize="small" /> : undefined}
                        onClick={() => this.navigateTo(route.link)}>
                        {route.name}
                      </Button>
                    );
                  })}

                  <Button
                    className="nav-link-btn abstract-btn"
                    color="secondary"
                    variant="outlined"
                    onClick={() => this.navigateTo("/registration")}>
                    Register Now
                  </Button>
                  <a
                    style={{
                      textDecoration: "none",
                      textTransform: "uppercase",
                    }}
                    href="/brochure-30Jul2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer">
                    <Button className="nav-link-btn abstract-btn">Download Brochure</Button>
                  </a>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
